export function buildQueryString(params?: Record<string, string | undefined>): string {
  if (!params) return '';
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) searchParams.append(key, value);
  }
  const qs = searchParams.toString();
  return qs ? `?${qs}` : '';
}

/**
 * Default staleTime for finance query hooks that don't need fresh data on
 * every mount or window-focus. Mutations call `invalidateQueries` explicitly,
 * so raising this value only suppresses the background refetch on navigation
 * and tab-switch — it never masks a real write.
 *
 * Hooks that intentionally stay at staleTime=0 (dialog-open fresh reads like
 * `useFilingPreflight`, `useFilingPreview`, `useMarkFiledPreview`) are
 * explicitly documented in their own hook bodies.
 */
export const FINANCE_STALE_TIME = 60_000; // 60 seconds
